export const config = {
  propsName: 'renderProps',
  name: 'SpSubdata',
  type: 'formTmpsConfig',
  icon: 'el-icon-circle-check',
  cnName: '表单提交',
  tooltip: 'SpTmp模版tooltip',
  exclusive: true,
  base: {
    flex: '2',
    margin: [0, 0, 0, 0]
    // buttonName:'按钮名称',
  },
  props: [
    {
      tooltip: '排列方式的tooltip',
      type: () => import('@/weappTmps/formTmps/SpSubdata/comps/flexBtn.vue'),
      cmpPath: '/formTmps/SpSubdata/comps/flexBtn.vue',
      key: 'flexBtn',
      bind: {
        label: '排列方式'
      },
      on: {},
      value: null
    },
    {
      type: 'el-input',
      key: 'buttonName',
      bind: {
        label: '按钮名称',
        placeholder: '请输入按钮名称'
      },
      value: '按钮名称'
    },
    {
      type: () => import('@/weappTmps/comps/fontWeight/index.vue'),
      cmpPath: '/comps/fontWeight/index.vue',
      key: 'fontWeight',
      bind: {
        // label: '排列方式',
      },
      on: {},
      value: null
    },

    {
      type: () => import('@/weappTmps/comps/color/index.vue'),
      cmpPath: '/comps/color/index.vue',
      key: 'color',
      bind: {},
      on: {},
      value: null
    },
    {
      type: () => import('@/weappTmps/comps/backgroundColor/index.vue'),
      cmpPath: '/comps/backgroundColor/index.vue',
      key: 'backgroundColor',
      bind: {},
      on: {},
      value: null
    },
    {
      type: () => import('@/weappTmps/comps/margin/index.vue'),
      cmpPath: '/comps/margin/index.vue',
      key: 'margin',
      bind: {
        label: '边距'
      },
      on: {},
      value: null
    },

    {
      // tooltip:'背景图的tooltip',
      type: () => import('@/weappTmps/comps/backgroundImg/index.vue'),
      cmpPath: '/comps/backgroundImg/index.vue',
      key: 'backgroundImg',
      bind: {
        label: '背景图'
      },
      on: {},
      value: null
    },
    {
      type: () => import('@/weappTmps/comps/borderRadius/index.vue'),
      cmpPath: '/comps/borderRadius/index.vue',
      key: 'borderRadius',
      bind: {
        label: '圆角度数（px）'
      },
      on: {},
      value: null
    }
  ]
}
